<template>
    <div>
        <div>
            <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryOnLoad="false" :queryHandler="queryHandler" :eventHandler="queryEventHanlder"></swb-query-sort-area>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);
    import comnApi from '../../api/comn'

    let sysDefPageSize = 10;

    let mockConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "valueType": "String",
                "label": "名称",
                "code": "name",
                "basic": true
            },
            {
                "type": "Text",
                "valueType": "String",
                "label": "标识",
                "code": "code",
                "basic": true
            }],
        "sortFields": []
    };


    export default {
        name: 'swb-mob-app-role-search',
        desc: '移动端（固定）角色查询',
        data: function () {
            return {
                queryConfig: mockConfigData,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {
                    }
                }
            }
        },
        created(){
            //查询排序配置信息
            let queryConfig = Utils.merge({},mockConfigData);
            //查询回调函数调用上下文对象
            //queryConfig.queryContext = this;
            //...
            this.queryConfig = queryConfig;
        },
        methods: {
            queryHandler: function (queryModel) {
                //查询条件

                this.$emit("queryHandler", queryModel)

                /*                //1、接收查询条件（并缓存）
                 this.queryModel = queryModel;

                 //2、直接获取查询条件
                 let query_model_ctrl = this.$refs['query_model'];
                 console.log(query_model_ctrl.getModel());*/

                //调用查询...

            },
            queryEventHanlder: function (postData) {

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/authx/MobAppRoleSearch.vue